export default __webpack_public_path__ + "static/media/loss-analysis-step-5.865f0fd0.gif";